"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentThreadT = exports.AgentThreadContentT = exports.AgentThreadSummaryT = exports.ThreadMetadataT = exports.CompletionRecordT = exports.ResponseT = exports.PendingQuestionT = exports.PendingChangeT = exports.isStoredAttachment = exports.isPendingAttachment = exports.ContentBlockAnyT = exports.INTELLIGENCE_TIERS = exports.DEFAULT_INTELLIGENCE_TIER = exports.IntelligenceTierT = exports.ModelKeyT = void 0;
const t = __importStar(require("@sinclair/typebox"));
const dates_1 = require("./dates");
const meta_types_1 = require("./meta-types");
exports.ModelKeyT = t.Union([
    t.Literal('gpt-sol-xhigh'),
    t.Literal('gpt-sol'),
    t.Literal('gpt-sol-high'),
    t.Literal('gpt-sol-low'),
    t.Literal('gpt-terra'),
    t.Literal('gpt-luna-xhigh'),
    t.Literal('gpt-luna'),
]);
exports.IntelligenceTierT = t.Union([
    t.Literal('light'),
    t.Literal('standard'),
    t.Literal('advanced'),
    t.Literal('maximum'),
]);
exports.DEFAULT_INTELLIGENCE_TIER = 'standard';
exports.INTELLIGENCE_TIERS = [
    {
        key: 'light',
        level: 1,
        name: 'Light',
        description: 'For simple tasks with clear instructions',
    },
    {
        key: 'standard',
        level: 2,
        name: 'Standard',
        description: 'Baseline quality for day-to-day tasks',
    },
    {
        key: 'advanced',
        level: 3,
        name: 'Advanced',
        description: 'For difficult tasks requiring more thought',
    },
    {
        key: 'maximum',
        level: 4,
        name: 'Maximum',
        description: 'Best possible results, ignoring time/cost',
    },
];
const ReasonBlockT = t.Object({
    title: t.String(),
    summary: t.String(),
});
const ToolInputT = t.Union([t.Record(t.String(), t.Any()), t.String()]);
const SearchToolCallT = t.Object({
    id: t.String(),
    name: t.String(),
    title: (0, meta_types_1.MaybeT)(t.String()),
    input: ToolInputT,
    output: (0, meta_types_1.MaybeT)(t.Unknown()),
    error: (0, meta_types_1.MaybeT)(t.String()),
    providerOptions: t.Optional(t.Record(t.String(), t.Any())),
});
const PresentationToolCallT = t.Object({
    id: t.String(),
    name: t.String(),
    widget: t.String(),
    title: (0, meta_types_1.MaybeT)(t.String()),
    input: ToolInputT,
    providerOptions: t.Optional(t.Record(t.String(), t.Any())),
});
const ChangeToolCallT = t.Object({
    id: t.String(),
    name: t.String(),
    widget: t.String(),
    title: (0, meta_types_1.MaybeT)(t.String()),
    input: ToolInputT,
    output: (0, meta_types_1.MaybeT)(t.Unknown()),
    error: (0, meta_types_1.MaybeT)(t.String()),
    providerOptions: t.Optional(t.Record(t.String(), t.Any())),
});
const EventToolCallT = t.Object({
    id: t.String(),
    name: t.String(),
    title: (0, meta_types_1.MaybeT)(t.String()),
    input: ToolInputT,
    output: (0, meta_types_1.MaybeT)(t.Unknown()),
    error: (0, meta_types_1.MaybeT)(t.String()),
    providerOptions: t.Optional(t.Record(t.String(), t.Any())),
});
const ToolCallT = t.Union([
    t.Object({ kind: t.Literal('search'), tool: SearchToolCallT }),
    t.Object({ kind: t.Literal('presentation'), tool: PresentationToolCallT }),
    t.Object({ kind: t.Literal('change'), tool: ChangeToolCallT }),
    t.Object({ kind: t.Literal('event'), tool: EventToolCallT }),
]);
const SummaryEventT = t.Object({
    timestamp: t.String(),
    status: t.String(),
});
const TimeTakenT = t.Object({
    waiting: (0, meta_types_1.MaybeT)(t.Number()),
    thinking: (0, meta_types_1.MaybeT)(t.Number()),
    tooling: (0, meta_types_1.MaybeT)(t.Number()),
    writing: (0, meta_types_1.MaybeT)(t.Number()),
    total: (0, meta_types_1.MaybeT)(t.Number()),
});
const UsageT = t.Object({
    inputTokens: t.Number(),
    outputTokens: t.Number(),
    reasoningTokens: t.Number(),
    cachedInputTokens: t.Number(),
    totalTokens: t.Number(),
    costCents: t.Number(),
});
const ContentBaseT = t.Object({
    role: t.Union([t.Literal('user'), t.Literal('assistant')]),
    timestamp: t.String(),
    authorUserID: t.Optional(t.Number()),
});
const ContentNewStepT = t.Intersect([
    ContentBaseT,
    t.Object({
        type: t.Literal('new-step'),
    }),
]);
const ContentTextT = t.Intersect([
    ContentBaseT,
    t.Object({
        type: t.Literal('text'),
        text: t.String(),
    }),
]);
const ContentSearchT = t.Intersect([
    ContentBaseT,
    t.Object({
        type: t.Literal('search'),
        tool: SearchToolCallT,
    }),
]);
const ContentPresentationT = t.Intersect([
    ContentBaseT,
    t.Object({
        type: t.Literal('presentation'),
        tool: PresentationToolCallT,
    }),
]);
const ContentChangeT = t.Intersect([
    ContentBaseT,
    t.Object({
        type: t.Literal('change'),
        tool: ChangeToolCallT,
    }),
]);
const ContentEventT = t.Intersect([
    ContentBaseT,
    t.Object({
        type: t.Literal('event'),
        tool: EventToolCallT,
    }),
]);
const ContentReasoningT = t.Intersect([
    ContentBaseT,
    t.Object({
        type: t.Literal('reasoning'),
        reasoning: ReasonBlockT,
    }),
]);
const ContentErrorT = t.Intersect([
    ContentBaseT,
    t.Object({
        type: t.Literal('error'),
        error: t.String(),
    }),
]);
const ContentSourceT = t.Intersect([
    ContentBaseT,
    t.Object({
        type: t.Literal('source'),
        source: t.Object({
            url: t.String(),
            title: (0, meta_types_1.MaybeT)(t.String()),
        }),
    }),
]);
const ContentImagePendingT = t.Intersect([
    ContentBaseT,
    t.Object({
        type: t.Literal('image-pending'),
        image: t.Object({
            data: t.String(),
            filename: t.String(),
            width: t.Number(),
            height: t.Number(),
        }),
    }),
]);
const ContentImageT = t.Intersect([
    ContentBaseT,
    t.Object({
        type: t.Literal('image'),
        image: t.Object({
            guid: t.String(),
            filename: t.String(),
            width: t.Number(),
            height: t.Number(),
        }),
    }),
]);
const ContentFilePendingT = t.Intersect([
    ContentBaseT,
    t.Object({
        type: t.Literal('file-pending'),
        file: t.Object({
            data: t.String(),
            filename: t.String(),
            mimeType: t.String(),
            size: t.Number(),
        }),
    }),
]);
const AttachmentManifestFileT = t.Object({
    id: t.String(),
    type: t.String(),
    filename: t.String(),
    title: (0, meta_types_1.MaybeT)(t.String()),
    description: (0, meta_types_1.MaybeT)(t.String()),
    mimeType: t.String(),
    size: t.Number(),
    sizeKB: t.Number(),
    pages: (0, meta_types_1.MaybeT)(t.Number()),
});
const ContentAttachmentManifestT = t.Intersect([
    ContentBaseT,
    t.Object({
        type: t.Literal('attachment-manifest'),
        files: t.Array(AttachmentManifestFileT),
    }),
]);
const ContentFileT = t.Intersect([
    ContentBaseT,
    t.Object({
        type: t.Literal('file'),
        file: t.Object({
            id: t.Optional(t.Number()),
            guid: t.String(),
            filename: t.String(),
            mimeType: t.String(),
            size: t.Number(),
            pages: t.Optional((0, meta_types_1.MaybeT)(t.Number())),
        }),
    }),
]);
exports.ContentBlockAnyT = t.Union([
    ContentNewStepT,
    ContentTextT,
    ContentSearchT,
    ContentPresentationT,
    ContentChangeT,
    ContentEventT,
    ContentReasoningT,
    ContentErrorT,
    ContentSourceT,
    ContentImagePendingT,
    ContentImageT,
    ContentFilePendingT,
    ContentAttachmentManifestT,
    ContentFileT,
]);
const isPendingAttachment = (block) => block.type === 'image-pending' || block.type === 'file-pending';
exports.isPendingAttachment = isPendingAttachment;
const isStoredAttachment = (block) => block.type === 'image' || block.type === 'file';
exports.isStoredAttachment = isStoredAttachment;
const TimersInputT = t.Object({
    sentRequest: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    startedInference: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    finishingThinking: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    finishedRequest: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
});
exports.PendingChangeT = t.Object({
    id: t.String(),
    toolName: t.String(),
    widget: t.String(),
    input: t.Unknown(),
    status: t.Optional(t.Union([
        t.Literal('pending'),
        t.Literal('approved'),
        t.Literal('executing'),
        t.Literal('rejected'),
        t.Literal('error'),
    ])),
});
exports.PendingQuestionT = t.Object({
    id: t.String(),
    toolName: t.Optional(t.String()),
    title: t.Optional(t.String()),
    question: t.String(),
    multiple: t.Boolean(),
    options: t.Array(t.String()),
    status: t.Literal('pending'),
});
exports.ResponseT = t.Object({
    id: t.String(),
    threadID: t.Optional(t.String()),
    intelligence: exports.IntelligenceTierT,
    status: t.Union([t.Literal('pending'), t.Literal('success'), t.Literal('error')]),
    currentStatus: t.String(),
    reasoning: t.Array(ReasonBlockT),
    tools: t.Array(ToolCallT),
    text: t.Array(t.String()),
    errors: t.Array(t.String()),
    content: t.Array(exports.ContentBlockAnyT),
    events: t.Array(SummaryEventT),
    pendingChanges: t.Optional(t.Array(exports.PendingChangeT)),
    clearPendingChanges: t.Optional(t.Boolean()),
    pendingQuestions: t.Optional(t.Array(exports.PendingQuestionT)),
    clearPendingQuestions: t.Optional(t.Boolean()),
    metrics: (0, meta_types_1.MaybeT)(t.Object({
        timers: TimersInputT,
        time: TimeTakenT,
        usage: UsageT,
    })),
});
exports.CompletionRecordT = t.Object({
    id: t.Number(),
    requestStart: t.String(),
    intelligence: exports.IntelligenceTierT,
    model: t.String(),
    tokensRead: t.Number(),
    tokensReadCached: t.Number(),
    tokensWritten: t.Number(),
    tokensReasoning: t.Number(),
    costMicrodollars: t.Number(),
    durationMs: t.Number(),
});
exports.ThreadMetadataT = t.Object({
    id: t.String(),
    agentType: t.String(),
    facility: (0, meta_types_1.MaybeT)(t.Number()),
    subFacility: (0, meta_types_1.MaybeT)(t.Number()),
    user: (0, meta_types_1.MaybeT)(t.Number()),
    title: (0, meta_types_1.MaybeT)(t.String()),
    parentTask: (0, meta_types_1.MaybeT)(t.String()),
    parentThread: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    status: t.String(),
    createdAt: (0, dates_1.DateTimeObjT)(),
    updatedAt: (0, dates_1.DateTimeObjT)(),
});
exports.AgentThreadSummaryT = t.Object({
    metadata: exports.ThreadMetadataT,
    firstMessagePreview: (0, meta_types_1.MaybeT)(t.String()),
    pendingChanges: t.Array(exports.PendingChangeT),
    pendingChangesCount: t.Number(),
    pendingQuestionsCount: t.Number(),
    contentCount: t.Number(),
    completionCount: t.Number(),
});
exports.AgentThreadContentT = t.Object({
    content: t.Array(exports.ContentBlockAnyT),
    pendingChanges: t.Array(exports.PendingChangeT),
    pendingQuestions: t.Array(exports.PendingQuestionT),
    completions: t.Array(exports.CompletionRecordT),
});
exports.AgentThreadT = t.Intersect([exports.AgentThreadSummaryT, exports.AgentThreadContentT]);
//# sourceMappingURL=types-llm-2.js.map